import $ from "jquery";
import App from "../src/App";
import Swiper from "swiper";
import "swiper/scss";

import gsap from "gsap";
import { Navigation } from "swiper/modules";

let mm = gsap.matchMedia();

mm.add("(max-width: 768px)", () => {
  let swiperElement = $(".js-menu-swiper-mobile");
  let swiperElementWrapper = $(".js-menu-swiper-mobile-wrapper");
  let swiperElementSlides = $(".js-menu-line");

  swiperElement.addClass("swiper");
  swiperElementWrapper.addClass("swiper-wrapper");
  swiperElementSlides.each(function () {
    $(this).addClass("swiper-slide");
  });

  const menuSwiperMobile = new Swiper(".js-menu-swiper-mobile", {
    modules: [Navigation],
    spaceBetween: 5,
    navigation: {
      nextEl: ".js-swiper-next",
      prevEl: ".js-swiper-prev",
    },
  });

  return () => {
    swiperElement.removeClass("swiper");
    swiperElementWrapper.removeClass("swiper-wrapper");
    swiperElementSlides.each(function () {
      $(this).removeClass("swiper-slide");
    });
    menuSwiperMobile.destroy();
  };
});
